
import React from 'react';

const PaymentTest = () => {
  return (
    <form
      name="frm_step1"
      action="https://lsc-india.com/payment/onlinepayment/lsc_payment_submit"
      method="POST"
      
    >
      <input type='hidden' name="source" value="EDCLMS" />
      <input type='hidden' name="key" value="LjF13ZAA57Rer97SkYUV7wIFfIKMPzoX" />
      <input type='hidden' name="transaction_id" value="EDCLMS2025091868c8f33834841" />
      <input type="hidden" name="amount" value="3540" />
      <input type='hidden' name="user_id" value="10" />
      <input type='hidden' name="username" value="Anbumani" />
      <input type='hidden' name="email" value="anbumani@lsc-india.com" />
      <input type='hidden' name="mobile" value="9080078716" />
      <input type='hidden' name="purpose" value="OCP Courses" />
      <input type='hidden' name="param1" value="2" />
      <input
        name="param2" type='hidden'
        value="Certificate Programme in Aviation & Air Cargo"
      />
      <input
        name="transaction_sent_dts"type='hidden'
        value="2025-09-16 19:10:43"
      />
      <input type='hidden' name="redirect_url" value="https:/p/postpay_cart.php" />
      <input type='hidden' name="bcc_email" value="anbumani@lsc-india.com" />
      <input type="submit" value="Click To Pay" />
    </form>
  );
};

export default PaymentTest;
